import { useShallow } from 'zustand/shallow'

import { Dialog, DialogContent } from '@/components/atoms/Dialog'
import EmailForm from '@/components/molecules/EmailForm'
import { useScopedI18n } from '@/locales/client'
import type { DialogTypes } from '@/stores/DialogsStore'
import useDialogsStore from '@/stores/DialogsStore'

const DIALOG_ID: DialogTypes = 'sendMyself'

function SendMyselfDialog() {
  const t = useScopedI18n('dialogs.sendMyself')
  const { open } = useDialogsStore(useShallow(state => state.dialogs.sendMyself))
  const toggle = useDialogsStore(useShallow(state => state.toggle))

  return (
    <Dialog open={open} onOpenChange={() => toggle(DIALOG_ID)}>
      <DialogContent className="flex h-fit flex-col items-center justify-center gap-8 p-12 text-center transition-all duration-300 ease-in-out">
        <EmailForm
          titleText={t('formTitle')}
          buttonText={t('formButton')}
        />
      </DialogContent>
    </Dialog>
  )
}

export default SendMyselfDialog
